// extracted by mini-css-extract-plugin
export var faqs = "styles-module--faqs--dOzmd";
export var category = "styles-module--category--EFMV+";